import firebase from 'firebase';

require('firebase/firestore');
require("firebase/performance");

const config = {
	apiKey: "AIzaSyATad9mdS85bZPesVOnJpSP3BSwVAg60aY",
	authDomain: "taksy-bacer.firebaseapp.com",
	//databaseURL: "https://taksy-bacer-test.firebaseio.com",
	databaseURL: "https://taksy-bacer.firebaseio.com",
	projectId: "taksy-bacer",
	storageBucket: "taksy-bacer.appspot.com",
	messagingSenderId: "368668879750",
	appId: "1:368668879750:web:d6073fe47be41eebe1da07",
	measurementId: "G-9X9GPN8LZZ"
};

firebase.initializeApp(config);
const perf = firebase.performance();


const database = firebase.database();
export default database;



// WEBPACK FOOTER //
// ./src/Components/BD/database.js